import { useEffect, useState } from 'react';
export function useMobilePreviewZoom(frameEl, referenceWidth) {
    const [zoom, setZoom] = useState(null);
    useEffect(()=>{
        if (!frameEl) return;
        const ro = new ResizeObserver((param)=>{
            let [entry] = param;
            const width = entry.contentRect.width;
            if (width > 0) setZoom(width / referenceWidth);
        });
        ro.observe(frameEl);
        return ()=>ro.disconnect();
    }, [
        frameEl,
        referenceWidth
    ]);
    return zoom;
}
